export const counter = document.querySelector("#counter");
